module.exports = __webpack_public_path__ + "static/analytics-2fbc9f16c2fb827976e6d19937f6be44.png";